import React, { useState, useEffect } from 'react';
import CarehomeAddress from '@components/team-member/organization-details/components/CarehomeAddress';
import { CarehomeAddressType } from '@typings/CarehomeInfo';
import AddressType from './AddressType';
// eslint-disable-next-line import/no-cycle
import { AddressDataType } from '../index';

interface AlternativeAddressProps {
  fullName: string;
  alternativeAddressType: string;
  setAlternativeAddressType: (value: string) => void;
  alternativeAddress: CarehomeAddressType;
  setAlternativeAddress: (address: CarehomeAddressType) => void;
  addressFromData: AddressDataType;
}

const AlternativeAddress: React.FC<AlternativeAddressProps> = ({
  fullName,
  alternativeAddressType,
  setAlternativeAddressType,
  alternativeAddress,
  setAlternativeAddress,
  addressFromData,
}) => {
  const [addressType, setAddressType] = useState('');
  const [carehomeAddress, setCarehomeAddress] = useState<CarehomeAddressType>({
    addressLine1: '',
    addressLine2: '',
    city: '',
    county: '',
    postCode: '',
  });

  useEffect(() => {
    setAlternativeAddress(carehomeAddress);
  }, [carehomeAddress, setAlternativeAddress]);

  useEffect(() => {
    if (addressFromData) {
      setCarehomeAddress(addressFromData.alternativeAddress);
      setAddressType(addressFromData.alternativeAddressType);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addressFromData]);

  useEffect(() => {
    setAlternativeAddressType(addressType);
  }, [addressType, setAlternativeAddressType]);

  return (
    <div>
      <h1 className="govuk-heading-l mt-10 govuk-bp:mt-14">
        {fullName
          ? `${fullName} alternative address (optional)`
          : 'Alternative address (optional)'}
      </h1>
      <AddressType addressType={addressType} setAddressType={setAddressType} />
      <CarehomeAddress
        carehomeAddress={carehomeAddress}
        setCarehomeAddress={setCarehomeAddress}
        notShowInitialAddress
      />
    </div>
  );
};

export default AlternativeAddress;
